/**
 *
 *
 * @param  {[type]} f [description]
 * @return {[type]}   [description]
 */
export default function unaryMemoize(f) {
  var cache = new Map();
  return function (arg) {
    var result = cache.get(arg);

    if (result) {
      return result;
    }

    result = f.apply(null, [arg]);
    cache.set(arg, result);
    return result;
  };
}